window.Products.Clothing.PremiumLongSleeveTShirt = function() {
};
window.Products.Clothing.PremiumLongSleeveTShirt.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.PremiumLongSleeveTShirt.dpi = 150;
window.Products.Clothing.PremiumLongSleeveTShirt.has_3d = true;
window.Products.Clothing.PremiumLongSleeveTShirt.id = 105;
window.Products.Clothing.PremiumLongSleeveTShirt.slug = 'premium-long-sleeve-t-shirt';
window.Products.Clothing.PremiumLongSleeveTShirt.syncColors = true;
window.Products.Clothing.PremiumLongSleeveTShirt.texturesLoaded = 0;
window.Products.Clothing.PremiumLongSleeveTShirt.texturesLoading = false;
window.Products.Clothing.PremiumLongSleeveTShirt.use_glb = true;

window.Products.Clothing.PremiumLongSleeveTShirt.prototype.outsideObject = 0;
window.Products.Clothing.PremiumLongSleeveTShirt.prototype.detailsObject = 1;
window.Products.Clothing.PremiumLongSleeveTShirt.prototype.position = 0.1;

window.Products.Clothing.PremiumLongSleeveTShirt.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}
	
	me.updateThreeTexture(modelViewer);

	var three_color = me.getColor(color);
	var three_intensity = 1.0;
	if(color.includes("heather")){
		three_intensity = 3;
		three_color.multiplyScalar(0.9);
	}
	object.children[0].children[me.detailsObject].material.color = three_color;

	me.updateThreeTexture(modelViewer);
	
	object.children[0].children[me.outsideObject].material.aoMapIntensity = three_intensity;
	object.children[0].children[me.detailsObject].material.aoMapIntensity = three_intensity / 10;
};

window.Products.Clothing.PremiumLongSleeveTShirt.prototype.getColor = function(_name){
	colors = {
		"white": 0xffffff,
		"black": 0x171616,
		"athletic_heather": 0xc7c8c9,
		"black_heather": 0x171616,
		"dark_heather_grey": 0x3e3f3f,
		"deep_heather": 0x717172,
		"navy": 0x262840,
		"heather_navy": 0x2e3766,
		"red": 0x901819,
	};

	return new THREE.Color(colors[_name]);
};